import React from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './TermsOfServicePage.module.css';

const TermsOfServicePage = () => {
  const layoutAreas = `
        topbar
        main
        footer
    `;

  return (
    <LayoutComposer areas={layoutAreas} className={css.root}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer currentPage="TermsOfServicePage" />
            </Topbar>
            <Main as="main" className={css.main}>
              <div className={css.content}>
                <h1 className={css.title}>Términos de Servicio</h1>
                <div className={css.lastUpdated}>
                  Última actualización: {new Date().toLocaleDateString('es-ES')}
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>1. Aceptación de los Términos</h2>
                  <p className={css.text}>
                    Al acceder y utilizar BioCerca, aceptas cumplir con estos Términos de Servicio.
                    Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar
                    nuestra plataforma.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>2. Descripción del Servicio</h2>
                  <p className={css.text}>
                    BioCerca es una plataforma digital que conecta directamente a agricultores con
                    consumidores, facilitando la compra y venta de productos locales sin
                    intermediarios. Nos comprometemos a:
                  </p>
                  <ul className={css.list}>
                    <li>Facilitar conexiones directas entre agricultores y consumidores</li>
                    <li>Mantener la integridad y seguridad de la plataforma</li>
                    <li>Proveer herramientas para una transacción transparente</li>
                    <li>Proteger los datos de nuestros usuarios</li>
                  </ul>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>3. Responsabilidades de los Usuarios</h2>

                  <h3 className={css.subsectionTitle}>3.1 Agricultores</h3>
                  <p className={css.text}>Los agricultores se comprometen a:</p>
                  <ul className={css.list}>
                    <li>Ofrecer información veraz sobre sus productos</li>
                    <li>Mantener la calidad y frescura de los productos</li>
                    <li>Respetar los acuerdos de entrega y recogida</li>
                    <li>Cumplir con las normativas sanitarias y de producción</li>
                  </ul>

                  <h3 className={css.subsectionTitle}>3.2 Consumidores</h3>
                  <p className={css.text}>Los consumidores se comprometen a:</p>
                  <ul className={css.list}>
                    <li>Respetar los precios y condiciones establecidas</li>
                    <li>Realizar los pagos de manera oportuna</li>
                    <li>Recoger los productos en los lugares y tiempos acordados</li>
                    <li>Comunicarse de manera respetuosa con los agricultores</li>
                  </ul>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>4. Tarifas y Comisiones</h2>
                  <p className={css.text}>
                    BioCerca cobra una comisión fija de 1,50€ por transacción para mantener la
                    plataforma operativa. Esta comisión se añade al total de la compra y no afecta
                    al precio que recibe el agricultor.
                  </p>
                  <p className={css.text}>
                    Los agricultores pueden tener sus propias tarifas de suscripción según el plan
                    contratado:
                  </p>
                  <ul className={css.list}>
                    <li>Primeros 3 meses: Gratuito</li>
                    <li>Meses 4-6: 19€/mes</li>
                    <li>Meses 7-9: 29€/mes</li>
                    <li>Meses 10-12: 39€/mes</li>
                    <li>A partir del mes 13: 49€/mes</li>
                  </ul>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>5. Propiedad Intelectual</h2>
                  <p className={css.text}>
                    Todo el contenido de BioCerca, incluyendo el diseño, logotipos, textos, gráficos
                    e imágenes, es propiedad de BioCerca o de sus licenciantes y está protegido por
                    las leyes de propiedad intelectual.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>6. Privacidad y Protección de Datos</h2>
                  <p className={css.text}>
                    Tu privacidad es importante para nosotros. El tratamiento de tus datos
                    personales se rige por nuestra Política de Privacidad, que forma parte
                    integrante de estos términos.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>7. Limitación de Responsabilidad</h2>
                  <p className={css.text}>
                    BioCerca actúa como intermediario tecnológico y no es responsable de:
                  </p>
                  <ul className={css.list}>
                    <li>La calidad o seguridad de los productos comercializados</li>
                    <li>Los acuerdos directos entre agricultores y consumidores</li>
                    <li>Incumplimientos de las normativas aplicables por parte de los usuarios</li>
                    <li>Pérdidas o daños derivados del uso de la plataforma</li>
                  </ul>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>8. Resolución de Disputas</h2>
                  <p className={css.text}>
                    Cualquier disputa entre usuarios deberá resolverse directamente entre las
                    partes. BioCerca podrá ofrecer mediación si ambas partes lo solicitan, pero no
                    se hace responsable del resultado final.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>9. Modificación de los Términos</h2>
                  <p className={css.text}>
                    BioCerca se reserva el derecho de modificar estos términos en cualquier momento.
                    Los cambios serán notificados a los usuarios y entrarán en vigor 30 días después
                    de su publicación.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>10. Terminación</h2>
                  <p className={css.text}>
                    BioCerca puede suspender o terminar cuentas que violen estos términos. Los
                    usuarios pueden cancelar su cuenta en cualquier momento desde su panel de
                    configuración.
                  </p>
                </div>

                <div className={css.section}>
                  <h2 className={css.sectionTitle}>11. Contacto</h2>
                  <p className={css.text}>
                    Para cualquier pregunta sobre estos términos, puedes contactarnos en:
                  </p>
                  <p className={css.contact}>
                    Teléfono: +696867268<br/> Correo: contacto@biocerca.es
                  </p>
                </div>
              </div>
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default TermsOfServicePage;
